import { render, staticRenderFns } from "./RequestSourcesContent.vue?vue&type=template&id=6a5408a8&"
import script from "./RequestSourcesContent.vue?vue&type=script&lang=js&"
export * from "./RequestSourcesContent.vue?vue&type=script&lang=js&"
import style0 from "./RequestSourcesContent.vue?vue&type=style&index=0&id=6a5408a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports